<template>
    <transition name="slide">
        <div class="modal fade" tabindex="-1" role="dialog" :class="oncancel ? 'show' : 'show'" :style="oncancel ? 'display: block; padding-left: 0px;' : ''">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content shadow-3">
                    <div class="modal-header">
                        <div class="icon icon-shape rounded-3 bg-soft-danger text-danger text-lg me-4">
                            <i class="bi bi-trash3"></i>
                        </div>
                        <div>
                            <h5 class="mb-1">{{ state == 24 ? 'Reembolsar': 'Anular' }} registro</h5>
                            <small class="d-block text-xs text-muted">¿Realmente desea <span style="text-transform: lowercase;">{{ state == 24 ? 'Reembolsar': 'Anular' }}</span> estos registros?<br> Este proceso no se puede deshacer.</small>
                        </div>
                        <div class="ms-auto">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <small class="text-sm">Nota</small>
                            <textarea class="form-control from-control-sm" rows="4" v-model="note"></textarea>
                        </div>
                        <div class="d-flex align-items-center">
                            <div>
                                <p class="text-sm">Ingresa tu contraseña para permitir esta acción</p>
                            </div>
                        </div>
                        <div>
                            <v-text-field
                                v-model="password"
                                :append-icon="type ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="type ? 'text' : 'password'"
                                class="form-control form-control-sm"
                                hide-details
                                @click:append="type = !type">
                            </v-text-field>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-h btn-danger px-3" @click="CANCEL()">
                            <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span v-else>Confirmar</span>
                        </button>
                        <button type="button" class="btn btn-h btn-dark px-3" @click="$emit('onclose')">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default{
    props: ['oncancel', 'id', 'state'],
    data(){
        return{
            note: '',
            password: '',
            state_id: '',
            type: false,
            count: 0
        }
    },
    methods: {
        CANCEL: function(){
            let vue = this
            vue.count++
            if (vue.count == 1) {
                vue.errors = {}
                axios({ url: '/invoice/cancel/' + vue.id, method: 'POST', data: { password: vue.password, note: vue.note, state_id: vue.state } })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        if(vue.state == 24){
                            vue.$emit('onclose')
                            vue.$emit('onreload')
                        }else{
                            vue.$router.push({ name: 'PackageIndex' })
                        }
                    })
                    .catch((err) => {
                        let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        }
    }
}
</script>